import { createQuery } from '@tanstack/solid-query'
import { api } from '~/services/api'

type UnlockedTreeEntry = {
  gid: number
  unlocked_at: string
}

export const unlockedTreesQueryKey = ['unlocked-trees'] as const

export const useUnlockedTrees = () => {
  return createQuery(() => ({
    queryKey: unlockedTreesQueryKey,
    queryFn: async () => {
      const result = await api.service
        .get('user/tree_types/unlocked_timestamps')
        .json<UnlockedTreeEntry[]>()
      return new Set((result ?? []).map((entry) => entry.gid))
    },
  }))
}
